import React from 'react';
import { Link, browserHistory } from 'react-router';
import {
  NoiDungKienNghi
} from './sub-view';
import { Collapse } from '@blueprintjs/core';
import moment from 'moment';
import { ContainerFileDinhKem } from 'components/upload';
import { TextMessage, Text, Input, TextArea, DatePicker } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { RowItemChiTietThanhVienCuocThanhTraView } from 'modules/thanh-tra/datatable';
import { Dialog } from "@blueprintjs/core";
import { ThanhTra, GiaiQuyetDonThu } from 'api';
import { DropDownMulipleUse } from 'components/tt-forms';
import { msg } from 'constants/message';
import { ConfirmDialog } from 'modules/dialog';
import { Toastr } from 'modules/toastr';
import { get } from 'lodash';
import { ChiTietDoiTuongThanhTraDialog } from 'modules/dialog';

const loaiQuyTrinh = 'THEO_DOI_THUC_HIEN_SAU_THANH_TRA';

class XuLyTheoDoiThucHien extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      dataDetail: [],
      id: this.props.params.id,
      showFile: false,
      listDoiTuongViPham: [],
      dataDonViBanHanh: [],
      type: this.props.type,
      showDoiTuongThanhTra: false,
      showThongTinThanhTra: true,
      showThongTinTheoDoi: true,
      enableKetThuc: false,
      isOpenConfirm: false,
      backConfirm: false,
      hasChange: false,
      doiTuongThanhTras: [],
      soVanBanChiDaoCuaCapTren: '',
      coQuanBanHanhChiDaoCuaCapTren: '',
      ghiChuVanBanChiDaoCuaCapTren: '',
      ngayBanHanhVanBanChiDaoCuaCapTren: '',

      soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT: '',

      // list tai lieu

      listTaiLieuChiDaoCuaCapTren: [],
      listTaiLieuKetQuaThucHienKetLuanThanhTra: [],
      listTaiLieuXuLyCuocThanhTra: [],

      listTaiLieuVanThuThanhTra: [],
      listTaiLieuVanThuThanhTraView: [],

      // data tai lieu dinh kem
      dataCanCuThanhTraLai: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        chiDaoCapTren: [],
        ketLuanThanhTra: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      isKiemTra: false,

      danhMucVanBans: [],
      chiTietDT: false,
    }
  }

  onFileChange(data, type) {
    if (type == 'CHI_DAO_CAP_TREN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.chiDaoCapTren = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'KET_QUA_THUC_HIEN_KET_LUAN_THANH_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.ketLuanThanhTra = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    if (type == 'CHI_DAO_CAP_TREN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.chiDaoCapTren = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'KET_QUA_THUC_HIEN_KET_LUAN_THANH_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.ketLuanThanhTra = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }

    this.handleChangeData();
  }


  getListDataFileDinhKem(type) {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.chiDaoCapTren.length > 0) {
      Data.chiDaoCapTren.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.ketLuanThanhTra.length > 0) {
      Data.ketLuanThanhTra.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  pushTaiLieu(id) {

    let dataFileDinhKem = this.getListDataFileDinhKem();

    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            cuocThanhTra: {
              id: Number(id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            cuocThanhTra: {
              id: Number(id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: loaiQuyTrinh,
            buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });
    }

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }

    if (this.state.taiLieuVanThu.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThu
      }
      this.postTaiLieuVanThu(params);
    }

    if (this.state.taiLieuVanThuUpdate.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuUpdate
      }
      this.updateTaiLieuVanThu(params);
    }

    if (this.state.taiLieuVanThuDelete.length > 0) {

      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuDelete
      }
      this.deleteTaiLieuVanThu(params);
    }
  }

  componentDidMount() {
    this.getDetail(this.state.id);
    this.getDonViBanHanh();
    this.getDataCanCuThanhTraLai();
  }

  getDataCanCuThanhTraLai() {
    ThanhTra.actions.getCanCuThanhTraLai.request().then(res => {
      if (res.data) {
        this.setState({
          dataCanCuThanhTraLai: res.data
        })
      }
    })
  }

  getCanCuThanhTraLai(value) {
    if (this.state.dataCanCuThanhTraLai.length > 0) {
      return this.state.dataCanCuThanhTraLai[this.state.dataCanCuThanhTraLai.findIndex(x => x.giaTri == value)].ten
    } else {
      return
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.params.id,
      type: nextProps.type
    })
  }

  getDetail(id) {
    ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        this.setState({
          dataDetail: res.data,
          soVanBanChiDaoCuaCapTren: res.data.soVanBanChiDaoCuaCapTren ? res.data.soVanBanChiDaoCuaCapTren : '',
          coQuanBanHanhChiDaoCuaCapTren: res.data.coQuanBanHanhChiDaoCuaCapTren ? res.data.coQuanBanHanhChiDaoCuaCapTren : '',
          ghiChuVanBanChiDaoCuaCapTren: res.data.ghiChuVanBanChiDaoCuaCapTren ? res.data.ghiChuVanBanChiDaoCuaCapTren : '',
          ngayBanHanhVanBanChiDaoCuaCapTren: res.data.ngayBanHanhVanBanChiDaoCuaCapTren ? new Date(res.data.ngayBanHanhVanBanChiDaoCuaCapTren) : '',

          soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra : '',
          coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra : '',
          ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra : '',
          ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT: res.data.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT ? new Date(res.data.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT) : '',
          danhMucVanBans: res.data.danhMucVanBans ? res.data.danhMucVanBans : []

        }, () => {
          this.checkListDoiTuongViPham();
          this.checkTypeCuocThanhTra();
        })
      }
    })
    this.getChiTietLienQuanCuocThanhTra(id);
  }

  getChiTietLienQuanCuocThanhTra(id) {
    ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        let Data = res.data;
        this.state.listTaiLieuChiDaoCuaCapTren = Data.listTaiLieuChiDaoCuaCapTren ? Data.listTaiLieuChiDaoCuaCapTren : [];
        this.state.listTaiLieuKetQuaThucHienKetLuanThanhTra = Data.listTaiLieuKetQuaThucHienKetLuanThanhTra ? Data.listTaiLieuKetQuaThucHienKetLuanThanhTra : [];
        this.state.listTaiLieuXuLyCuocThanhTra = Data.listTaiLieuXuLyCuocThanhTra ? Data.listTaiLieuXuLyCuocThanhTra : [];
        this.state.showFile = false;
        this.setState({
          ...this.state
        }, () => {
          this.checkFileRequire();
        })
      }
    })
  }

  getParams() {
    let params = this.state.dataDetail;
    if (params.doiTuongThanhTraInfo) {
      params.doiTuongThanhTra = {
        id: params.doiTuongThanhTraInfo.doiTuongThanhTraId
      }
    } else {
      params.doiTuongThanhTra = null
    }

    let getItems = [];
    if (params.listDoiTuongThanhTra) {
      params.listDoiTuongThanhTra.forEach(item => {
        getItems.push({
          id: item.doiTuongThanhTraId,
          ten: item.ten
        });
      })
    }
    params.doiTuongThanhTras = getItems;

    if (params.donViChuTriInfo) {
      params.donViChuTri = {
        id: Number(params.donViChuTriInfo.coQuanQuanLyId)
      }
    } else {
      params.donViChuTri = null;
    }


    if (params.thanhVienDoan == true && params.listThanhVienDoan.length > 0) {
      let data = [...params.listThanhVienDoan];
      let thanhVienDoans = [];
      data.map(state => {
        let newItem = {
          chucVu: state.chucVu ? state.chucVu : '',
          donVi: state.donVi ? state.donVi : '',
          hoVaTen: state.hoVaTen ? state.hoVaTen : '',
          ngaySinh: state.ngaySinh ? moment(new Date(state.ngaySinh)).add(7, 'hours').toISOString() : '',
          vaiTroThanhVienDoan: state.vaiTroThanhVienDoan ? state.vaiTroThanhVienDoan : null,
        }
        if (state.thanhVienDoanId) {
          newItem.id = Number(state.thanhVienDoanId)
        }
        thanhVienDoans[thanhVienDoans.length] = newItem;
      })
      params.thanhVienDoans = thanhVienDoans;
    }

    if (params.linhVucThanhTra) {
      params.linhVucThanhTra = params.linhVucThanhTra.giaTri
    }

    if (params.tienDoThanhTraInfo) {
      params.tienDoThanhTra = params.tienDoThanhTraInfo.type;
    } else {
      params.tienDoThanhTra = null
    }

    if (params.keHoachThanhTraInfo) {
      params.keHoachThanhTra = {
        id: params.keHoachThanhTraInfo.keHoachThanhTraId
      }
    } else {
      params.keHoachThanhTra = null
    }

    // field xu ly
    params.soVanBanChiDaoCuaCapTren = this.state.soVanBanChiDaoCuaCapTren ? this.state.soVanBanChiDaoCuaCapTren : '';
    params.coQuanBanHanhChiDaoCuaCapTren = this.state.coQuanBanHanhChiDaoCuaCapTren ? this.state.coQuanBanHanhChiDaoCuaCapTren : null;
    params.ghiChuVanBanChiDaoCuaCapTren = this.state.ghiChuVanBanChiDaoCuaCapTren ? this.state.ghiChuVanBanChiDaoCuaCapTren : '';
    params.ngayBanHanhVanBanChiDaoCuaCapTren = this.state.ngayBanHanhVanBanChiDaoCuaCapTren ? moment(this.state.ngayBanHanhVanBanChiDaoCuaCapTren).add(7, 'hours').toISOString() : null;

    params.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra = this.state.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra ? this.state.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra : '';
    params.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra = this.state.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra ? this.state.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra : null;
    params.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra = this.state.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra ? this.state.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra : '';
    params.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT = this.state.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT ? moment(this.state.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT).add(7, 'hours').toISOString() : null;

    params.danhMucVanBans = this.state.danhMucVanBans.filter(item => !!item.danhMucVanBanId).map(item => ({ id: item.danhMucVanBanId }));
    params.linhVucThanhTraList = params.linhVucThanhTraList ? params.linhVucThanhTraList.map(item => item.giaTri) : null;

    delete params['_links'];
    delete params['nguoiSuaInfo'];
    delete params['nguoiTaoInfo'];
    delete params['ngaySua'];
    delete params['ngayTao'];
    delete params['coQuanDieuTraInfo'];
    delete params['doiTuongThanhTraInfo'];
    delete params['donViChuTriInfo'];
    delete params['keHoachThanhTraInfo'];
    delete params['donViInfo'];
    delete params['hinhThucThanhTraInfo'];
    delete params['linhVucThanhTraInfo'];
    delete params['loaiHinhThanhTraInfo'];
    delete params['listTaiLieuVanThu'];
    delete params['listTaiLieuVanThuGiaHan'];
    delete params['listTaiLieuVanThuKetLuanThanhTra'];
    delete params['linhVucThanhTraChiTietInfo'];
    delete params['cuocThanhTraId'];
    delete params['listThanhVienDoan'];
    delete params['tienDoThanhTraInfo'];
    delete params['thoiHanThanhTraInfo'];
    delete params['listTaiLieuVanThuThongBaoKetThucTTTT'];
    delete params['listTaiLieuVanThuThongTinCuocThanhTra'];
    delete params['listDoiTuongThanhTra'];
    delete params['chucNangCuocThanhTraInfo'];
    delete params['listDoiTuongViPham'];
    delete params['thucHienPhapLuatVeThanhTraInfo'];
    delete params['listTaiLieuChiDaoCuaCapTren'];
    delete params['listTaiLieuKetQuaThucHienKetLuanThanhTra'];
    delete params['listTaiLieuXuLyCuocThanhTra'];
    delete params['listCoQuanToChucLienQuan'];
    delete params['keHoachThanhTraCuInfo'];
    delete params['keHoachThanhTraGocInfo'];
    delete params['keHoachThanhTraSearchInfo'];
    delete params['hinhThucThanhTraChuyenNganhInfo'];
    delete params['nguoiBanHanhThongBaoKetThucTTTTInfo'];

    return params;
  }

  checkIsKiemTra() {
    const result = window.location.pathname.includes('kiem-tra') || this.state.isKiemTra || get(this.state, 'dataDetail.loaiCuoc.value') === 'KIEM_TRA';
    return result;
  }

  handleSave() {
    this.setState({
      btnLoading: true,
      btnSaveLoading: true
    })
    let params = this.getParams();
    params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
    this.pushTaiLieu(this.state.id);
    ThanhTra.actions.patchCuocThanhTra.request({ id: this.state.id }, params).then(res => {
      if (res.data) {
        this.handleBack(true)
        Toastr(msg.saveCuocTTSuccess, 'success');
      }
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
      this.setState({
        btnLoading: false,
        btnSaveLoading: false
      })
    });
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });

    return pass;
  }

  componentWillUnmount() {

  }

  checkFileRequire() {
    // check file chi dao cap tren

    let dataChiDaoCuaCapTren = [...this.state.listTaiLieuChiDaoCuaCapTren];
    let dataChiDaoCuaCapTrenCheck = dataChiDaoCuaCapTren.filter(state => {
      return state.required && state.typeRequired == 'CHI_DAO_CAP_TREN'
    });

    if (dataChiDaoCuaCapTrenCheck.length > 0) {
      this.setState({
        listTaiLieuChiDaoCuaCapTren: dataChiDaoCuaCapTren,
        showFile: true
      })
    } else {
      let newItem = {
        ten: 'Văn bản chỉ đạo',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'CHI_DAO_CAP_TREN',
        newFile: true
      }
      this.setState({
        listTaiLieuChiDaoCuaCapTren: [
          ...dataChiDaoCuaCapTren,
          newItem
        ],
        showFile: true
      })
    }

    //check file thanh tra chuyen qua
    let data = [...this.state.listTaiLieuXuLyCuocThanhTra];
    let dataView = [...this.state.listTaiLieuXuLyCuocThanhTra];

    let listTaiLieuVanThuThanhTra = data.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataDetail.ngayChuyenTheoDoiThucHien), 'action');
    })

    let listTaiLieuVanThuThanhTraView = dataView.filter(state => {
      return this.compareDate(new Date(this.state.dataDetail.ngayChuyenTheoDoiThucHien), new Date(state.ngayTao), 'show');
    })
    this.setState({
      listTaiLieuVanThuThanhTra: listTaiLieuVanThuThanhTra,
      listTaiLieuVanThuThanhTraView: listTaiLieuVanThuThanhTraView
    }, () => {
      this.setState({
        showFile: true
      })
    })
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime >= secondTime && type == 'show') {
      return true
    } else {
      return false
    }
  }

  checkTypeCuocThanhTra() {
    if (this.state.dataDetail.keHoachThanhTraInfo == null) {
      this.setState({
        type: 'DOT_XUAT'
      })
    } else {
      this.setState({
        type: 'KE_HOACH'
      })
    }
  }

  getDonViBanHanh() {
    ThanhTra.actions.getListDonViBanHanh.request().then(res => {
      if (res.data) {
        this.setState({
          dataDonViBanHanh: res.data
        })
      }
    })
  }

  checkListDoiTuongViPham() {
    let Data = this.state.dataDetail;
    let listDoiTuongViPham = [];
    let doiTuongThanhTraLienQuan = [];
    let doiTuongThanhTras = [...Data.listDoiTuongThanhTra];
    let doiTuongThanhTra = Data.doiTuongThanhTraInfo;
    let data = Data.doiTuongThanhTraLienQuan.split('; ');
    if (data.length > 0) {
      data.map(state => {
        if (state) {
          doiTuongThanhTraLienQuan[doiTuongThanhTraLienQuan.length] = {
            ten: state
          }
        }
      })
    }
    if (doiTuongThanhTraLienQuan.length > 0) {
      doiTuongThanhTraLienQuan.map(state => {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: state.ten,
          giaTri: state.ten
        }
      })
    }
    if (doiTuongThanhTras.length > 0) {
      doiTuongThanhTras.map(state => {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: state.ten,
          giaTri: state.ten
        }
      })
    }
    if (doiTuongThanhTra) {
      listDoiTuongViPham[listDoiTuongViPham.length] = {
        ten: doiTuongThanhTra.ten,
        giaTri: doiTuongThanhTra.ten
      }
    }
    this.setState({
      listDoiTuongViPham: listDoiTuongViPham
    })
  }

  showDoiTuongThanhTra() {
    this.setState({
      showDoiTuongThanhTra: true
    })
  }

  hideDoiTuongThanhTra() {
    this.setState({
      showDoiTuongThanhTra: false
    })
  }

  handleCollapse(name) {
    this.setState({
      [name]: !this.state[name]
    })

  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
    this.handleChangeData();
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
    this.handleChangeData();
  }

  updateTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  setEnableKetThuc(state) {
    this.setState({
      enableKetThuc: state
    })
  }

  openDialog() {
    if (this.state.showThongTinTheoDoi == true) {
      if (this.validateSubmitForm()) {
        this.setState({
          isOpenConfirm: true
        })
      }
    } else {

      this.setState({
        showThongTinTheoDoi: true
      }, () => {
        let self = this;
        setTimeout(function () {
          if (self.validateSubmitForm()) {
            self.setState({
              isOpenConfirm: true
            })
          }
        }, 100)
      })
    }
  }

  closeDialog() {
    this.setState({
      isOpenConfirm: false
    })
  }

  handleKetThuc() {
    this.setState({
      isOpenConfirm: false,
      btnLoading: true,
      btnSaveLoading: true
    })
    let params = this.getParams();
    params.tienDoThanhTra = 'LUU_HO_SO';
    params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
    this.pushTaiLieu(this.state.id);
    ThanhTra.actions.patchCuocThanhTra.request({ id: this.state.id }, params).then(res => {
      if (res.data) {
        this.handleBack(true)
        Toastr(msg.tdthLuuHoSo, 'success');
      }
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
      this.setState({
        btnLoading: false,
        btnSaveLoading: false
      })
    });
  }

  handleBack(allowBack, type) {
    if (allowBack) {
      if (type == 'close') {
        this.checkNoiDungKienNghi()
        browserHistory.goBack();
      } else {
        browserHistory.goBack();
      }
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({ ...this.state });
      } else {
        browserHistory.goBack();
      }
    }
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({ ...this.state });
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    })
  }

  onOpenDialog() {
    this.setState({
      chiTietDT: true
    });
  }

  toggleDialog() {
    this.setState({
      chiTietDT: false
    });
  }

  render() {
    let Data = this.state.dataDetail;
    let DataDetail = this.state.dataDetail;
    let DoiTuongThanhTra = '';
    let tenDoiTuongThanhTraTKH = '';
    let CountDoiTuongThanhTra = 0;
    let CountDonViPhoiHop = 0;
    let CountDoiTuongThanhTraLienQuan = 0;
    let chucNangThanhTra = '';
    if (Data && Data.cuocThanhTraNhieuDoiTuong === false && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
      tenDoiTuongThanhTraTKH = Data.listDoiTuongThanhTra[0].ten;
    } else if (Data && Data.cuocThanhTraNhieuDoiTuong && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
      tenDoiTuongThanhTraTKH = `${Data.listDoiTuongThanhTra.length} đối tượng`;
    }
    if (DataDetail && DataDetail.chucNangCuocThanhTraInfo && DataDetail.chucNangCuocThanhTraInfo.text) {
      chucNangThanhTra = DataDetail.chucNangCuocThanhTraInfo.text;
    }
    if (Data.donViPhoiHop) {
      CountDonViPhoiHop = Data.donViPhoiHop.split('; ').length
    }
    if (Data.doiTuongThanhTraLienQuan) {
      CountDoiTuongThanhTraLienQuan = Data.doiTuongThanhTraLienQuan.split('; ').length
    }

    if (Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
      Data.listDoiTuongThanhTra.map((state, index) => {
        if (index == 0) {
          DoiTuongThanhTra = DoiTuongThanhTra + state.ten;
        } else {
          DoiTuongThanhTra = DoiTuongThanhTra + '; ' + state.ten;
        }
      })
      CountDoiTuongThanhTra = Data.listDoiTuongThanhTra.length
    }
    let data = [...this.state.dataDonViBanHanh]
    let dataFilter = data.filter(state => {
      return state.giaTri == Data.donViBanHanh
    })
    let donViBanHanh = '';
    if (dataFilter.length > 0) {
      donViBanHanh = dataFilter[0].ten
    }
    const isKiemTra = get(DataDetail, 'loaiCuoc.value') === 'KIEM_TRA';
    const loaiCuocText = isKiemTra ? 'kiểm tra' : 'thanh tra';
    const keHoachText = isKiemTra ? 'KHKT' : 'KHTT';
    return (
      <div className="center reception-container wrap-block custom-collapse">
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />
        <div className="back-foward">
          <Link onClick={this.handleBack.bind(this, false, 'close')} title="">Về trang trước</Link>
        </div>
        <div className="heading">
          <h2 className="heading-title icon-add">
            Theo dõi thực hiện sau {loaiCuocText}
          </h2>
        </div>
        <div className="bottom-content">
          <h2 className={`collapse-title pl20 pr20 pt20 ${this.state.showThongTinThanhTra ? "collapse-open" : "collapse-close"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showThongTinThanhTra')}>1. Thông tin {loaiCuocText}</Link></h2>
          <div className='pl20 pr20 pt20'>
            <div className='line-border'></div>
          </div>
          <ShowIf condition={Data && Data.hinhThucThanhTra === 'THEO_KE_HOACH'}>
            {/*thông tin cuộc thanh tra*/}
            <section className='wrap-block'>
              <div className='row pl15 pr15'>
                <h2 className='title-12 p20'>1.1. Thông tin kế hoạch {loaiCuocText}</h2>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Năm ${loaiCuocText}:`} className='col-20' value={`Kế hoạch ${loaiCuocText} năm ${DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.namThanhTra : ''}`} />
                <Text label={`Quyết định phê duyệt ${keHoachText}:`} className='col-20' value={DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.quyetDinhPheDuyetKTTT : ''} />
                <Text label='Ngày phê duyệt:' className='col-20' value={DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh ? moment(DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                <Text label='Người ký:' className='col-20' value={DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.nguoiKy : ''} />
              </div>
            </section>
            {/*end thông tin cuộc thanh tra*/}
            <div className='mt10 pl20 pr20'>
              <div className='line-border'></div>
            </div>
          </ShowIf>
          {/*thông tin cuộc thanh tra*/}
          <section className='wrap-block'>
            <ShowIf condition={this.state.type === 'DOT_XUAT'}>
              <div className='row pl15 pr15'>
                <h2 className='title-12 p20'>1.1. Thông tin cuộc {loaiCuocText}</h2>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Năm ${loaiCuocText}:`} className='col-25 mb10' value={Data.namThanhTra ? Data.namThanhTra : ''} />
                <Text link label={`Đối tượng ${loaiCuocText}:`} className='col-75 mb10' onClick={this.onOpenDialog.bind(this)} value={tenDoiTuongThanhTraTKH} />
                <Text label={`Tên cuộc ${loaiCuocText}:`} className='col-100 mb10' value={Data.ten ? Data.ten : ''} />
                {/*comment popup tên đối tượng*/}
                <Text label={`Thời kỳ ${loaiCuocText}:`} className='col-25 mb10' value={Data.kyThanhTra ? Data.kyThanhTra : ''} />
                <TextMessage label={`Nội dung ${loaiCuocText}:`} className='col-100 mb10' value={Data.noiDungThanhTra ? Data.noiDungThanhTra : ''} />
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Số quyết định về việc ${loaiCuocText}:`} className='col-25 mb10' value={Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : ''} />
                <Text label='Ngày ra quyết định:' className='col-25 mb10' value={Data.ngayRaQuyetDinh ? moment(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                <Text label='Loại hình:' value={Data.loaiHinhThanhTraInfo ? Data.loaiHinhThanhTraInfo.text : ''} className='col-25 mb10' />
                <ShowIf condition={Data.loaiHinhThanhTra === 'THANH_TRA_LAI'}>
                  <Text label={`Căn cứ ${loaiCuocText} lại:`} value={Data.canCuThanhTraLai ? this.getCanCuThanhTraLai(Data.canCuThanhTraLai) : ''} className='col-100 mb10' />
                </ShowIf>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Ngày công bố QĐ ${loaiCuocText}:`} className='col-25 mb10' value={Data.ngayCongBoQuyetDinhThanhTra ? moment(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : ''} />
                <Text label={`Thời hạn ${loaiCuocText} (ngày làm việc):`} type='sdt' className='col-25 mb10' value={`${Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0} ngày (${Data.ngayHetHanThanhTra ? moment(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : ''})`} />
                <Text label='Hình thức:' className='col-25 mb10' value={Data.hinhThucThanhTraInfo ? Data.hinhThucThanhTraInfo.text : ''} />
                <ShowIf condition={Data.hinhThucThanhTra === 'DOT_XUAT'}>
                  <TextMessage label={`Căn cứ ${loaiCuocText} đột xuất:`} className='col-100 mb10' value={Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : ''} />
                </ShowIf>
              </div>
              <Collapse className="wrap-collapses" isOpen={this.state.showThongTinThanhTra}>
                <div className='row pl30 pr30'>
                  <Text label={`Chức năng ${loaiCuocText}:`} className='col-25 mb10' value={Data.chucNangCuocThanhTraInfo ? Data.chucNangCuocThanhTraInfo.text : ''} />
                  <ShowIf condition={Data.chucNangCuocThanhTra === 'HANH_CHINH'}>
                    <Text label={`Lĩnh vực ${loaiCuocText}:`} className='col-25 mb10' value={Data.linhVucThanhTraList ? Data.linhVucThanhTraList.map(item => item.ten).join(', ') : ''} />
                  </ShowIf>
                  <ShowIf condition={DataDetail.chucNangCuocThanhTra === 'CHUYEN_NGANH'}>
                    <Text label={`Hình thức ${loaiCuocText} chuyên ngành:`} className='col-25 mb10' value={Data.hinhThucThanhTraChuyenNganhInfo && Data.hinhThucThanhTraChuyenNganhInfo.text ? Data.hinhThucThanhTraChuyenNganhInfo.text : ''} />
                  </ShowIf>
                </div>
                {/* <div className='row pl30 pr30'>
                    <Text label='Đơn vị chủ trì:' className='col-25 mb10' value={Data.donViChuTriInfo ? Data.donViChuTriInfo.ten : ''}/>
                  </div> */}
              </Collapse>
            </ShowIf>

            <ShowIf condition={this.state.type === 'KE_HOACH'}>
              <div className='row pl15 pr15'>
                <h2 className='title-12 p20'>1.2. Thông tin cuộc {loaiCuocText}</h2>
              </div>
              <div className='row pl30 pr30'>
                {/* comment popup show detail đói tượng thanh tra*/}
                <Text link label={`Đối tượng ${loaiCuocText}:`} className='col-25 mb10' onClick={this.onOpenDialog.bind(this)} value={tenDoiTuongThanhTraTKH} />
                <Text label={`Thời kỳ ${loaiCuocText}:`} className='col-25 mb10' value={Data.kyThanhTra ? Data.kyThanhTra : ''} />
                <Text label={`Tên cuộc ${loaiCuocText}:`} className='col-100 mb10' value={Data.ten ? Data.ten : ''} />
                <TextMessage label={`Nội dung ${loaiCuocText}:`} className='col-100 mb10' value={Data.noiDungThanhTra ? Data.noiDungThanhTra : ''} />
              </div>
            </ShowIf>
          </section>
          <section className='wrap-block mb10'>
            <ShowIf condition={this.state.type === 'KE_HOACH'}>
              <div className='row pl30 pr30'>
                <Text label={`Số quyết định về việc ${loaiCuocText}:`} className='col-25 mb10' value={Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : ''} />
                <Text label='Ngày ra quyết định:' className='col-25 mb10' value={Data.ngayRaQuyetDinh ? moment(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                <Text label={`Ngày công bố QĐ ${loaiCuocText}:`} className='col-25 mb10' value={Data.ngayCongBoQuyetDinhThanhTra ? moment(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : ''} />
                <Text label={`Thời hạn ${loaiCuocText} (ngày làm việc):`} type='sdt' className='col-25 mb10' value={`${Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0} ngày (${Data.ngayHetHanThanhTra ? moment(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : ''})`} />
              </div>
            </ShowIf>
            <Collapse className="wrap-collapses" isOpen={this.state.showThongTinThanhTra}>
              <div className='row pl30 pr30'>
                <ShowIf condition={this.state.type === 'KE_HOACH'}>
                  <Text label={`Chức năng ${loaiCuocText}:`} className='col-25 mb10' value={Data.chucNangCuocThanhTraInfo ? Data.chucNangCuocThanhTraInfo.text : ''} />
                  <ShowIf condition={Data.chucNangCuocThanhTra !== 'CHUYEN_NGANH'}>
                    <Text label={`Lĩnh vực ${loaiCuocText}:`} className='col-25 mb10' value={Data.linhVucThanhTraList ? Data.linhVucThanhTraList.map(item => item.ten).join(', ') : ''} />
                  </ShowIf>
                  <ShowIf condition={DataDetail.chucNangCuocThanhTra === 'CHUYEN_NGANH'}>
                    <Text label={`Hình thức ${loaiCuocText} chuyên ngành:`} className='col-25 mb10' value={Data.hinhThucThanhTraChuyenNganhInfo && Data.hinhThucThanhTraChuyenNganhInfo.text ? Data.hinhThucThanhTraChuyenNganhInfo.text : ''} />
                  </ShowIf>
                  <ShowIf condition={Data.hinhThucThanhTra === 'DOT_XUAT'}>
                    <TextMessage label={`Căn cứ ${loaiCuocText} đột xuất:`} className='col-100 mb10' value={Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : ''} />
                  </ShowIf>
                  {/* <Text label='Đơn vị chủ trì:' className='col-25 mb10' value={Data.donViChuTriInfo ? Data.donViChuTriInfo.ten : ''}/> */}
                </ShowIf>
                {/* <Text label='Đơn vị phối hợp:' className='col-100 mb10' value={Data.donViPhoiHop ? Data.donViPhoiHop : ''}/> */}
                {/* <Text label='Tổng số đơn vị phối hợp:' className='col-100 mb10' value={CountDonViPhoiHop}/> */}
                {/* <Text link label='Đối tượng thanh tra:' className='col-100 mb10' onClick={this.onOpenDialog.bind(this)} value={tenDoiTuongThanhTraTKH} /> */}
                <Text label={`Tổng số đối tượng ${loaiCuocText}:`} className='col-100 mb10' value={CountDoiTuongThanhTra} />
                <Text label={`Đối tượng ${loaiCuocText} liên quan:`} className='col-100 mb10' value={Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : ''} />
                <Text label={`Tổng số đối tượng ${loaiCuocText} liên quan:`} className='col-100 mb10' value={CountDoiTuongThanhTraLienQuan} />
              </div>
            </Collapse>
          </section>
          <Collapse className="wrap-collapses" isOpen={this.state.showThongTinThanhTra}>
            {/*end thông tin cuộc thanh tra*/}
            {/*Thành viên đoàn*/}
            <ShowIf condition={Data.chucNangCuocThanhTra === 'CHUYEN_NGANH' && Data.thanhVienDoan}>
              <div>
                <div className='pl20 pb20 pr20'>
                  <div className='line-border'></div>
                </div>
                <section className='row pl35 pr35 mb10'>
                  <div className='col-100 no-gutter'>
                    <h2 className='title-12 mb10'>{this.state.type === 'KE_HOACH' ? "1.2.1 Thành viên đoàn" : '1.1.1 Thành viên đoàn'}</h2>
                    <div className='row pl10 pr10'>
                      <Text label='Số quyết định:' className='col-25 mb0-18' value={Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : ''} />
                      <Text label='Ngày quyết định:' className='col-25 mb0-18' value={Data.ngayRaQuyetDinhThanhLapDoan ? moment(Data.ngayRaQuyetDinhThanhLapDoan).format('DD/MM/YYYY') : ''} />
                    </div>
                    <div className='wrap-table-show-oncheck white-table'>
                      <DataTable
                        header={header.thanhTra.TMTVCTTV}
                        dataList={Data.listThanhVienDoan ? Data.listThanhVienDoan : []}
                        pageData={this.state.pageData}
                        parent={this}
                        hideButtonExport
                        hidePagination={true}
                        search={this.state.search}
                        tableLoading={this.state.tableLoading}>
                        <RowItemChiTietThanhVienCuocThanhTraView linhVucThanhTra={Data.linhVucThanhTra ? Data.linhVucThanhTra : ''} />
                      </DataTable>
                    </div>
                  </div>
                </section>
              </div>
            </ShowIf>
            {/*end Thành viên đoàn*/}
            {/*Gia hạn*/}
            <ShowIf condition={Data.giaHan}>
              <div className='pl20 pb20 pr20'>
                <div className='line-border'></div>
              </div>
              <section className='pl35 pr35 row mb20'>
                <div className='col-100 block-gray p10 pl15 pr15'>
                  <h2 className='txt-12 txt-bold txt-upper pt10 mb15'>Gia hạn</h2>
                  <div className='row pl10 pr10'>
                    <Text className="col-25 mb10" label='Số quyết định:' value={Data.soQuyetDinhGiaHan ? Data.soQuyetDinhGiaHan : ''} />
                    <Text className="col-25 mb10" label='Ngày ra quyết định:' value={Data.ngayRaQuyetDinhGiaHan ? moment(Data.ngayRaQuyetDinhGiaHan).format('DD/MM/YYYY') : ''} />
                    <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={Data.lyDonGiaHan ? Data.lyDonGiaHan : ''} />
                  </div>
                </div>
              </section>
            </ShowIf>
            {/*end Gia hạn*/}
            <ShowIf condition={true}>
              <div className='row pl35 pr35 pb20'>
                <div className='col-100 block-gray p10'>
                  <div className='row pl20 pr20'>
                    <h2 className='txt-12 txt-bold txt-upper pt10 pb15'>Thông báo kết thúc {loaiCuocText} trực tiếp</h2>
                  </div>
                  <div className='row pl15 pr15'>
                    <div className='col-100 no-gutter'>
                      <Text label='Số thông báo:' className='col-25 mb10' value={Data.soThongBaoKetThucTTTT ? Data.soThongBaoKetThucTTTT : ''} />
                      <Text label='Ngày ban hành:' className='col-25 mb10' value={Data.ngayBanHanhThongBaoKetThucTTTT ? moment(Data.ngayBanHanhThongBaoKetThucTTTT).format('DD/MM/YYYY') : ''} />
                      <Text label='Người ban hành:' className='col-25 mb10' value={Data.nguoiBanHanhThongBaoKetThucTTTTInfo ? Data.nguoiBanHanhThongBaoKetThucTTTTInfo.hoVaTen : ''} />
                    </div>
                    <TextMessage label='Ghi chú:' className='col-100' value={Data.ghiChu ? Data.ghiChu : ''} />
                  </div>
                </div>
              </div>
            </ShowIf>
            <ShowIf condition={true}>
              <div>
                <section className='wrap-block pb10'>
                  <div className='row pl15 pr15'>
                    <div className='col-100 no-gutter pl20 pr20 pb20'>
                      <div className='line-border'></div>
                    </div>
                    <h2 className='title-12 p20'>{this.state.type === 'KE_HOACH' ? `1.3 Kết luận ${loaiCuocText}` : `1.2 Kết luận ${loaiCuocText}`}</h2>
                  </div>
                  <div className='row pl30 pr30'>
                    <div className='col-100 no-gutter'>
                      <Text label={`Số kết luận ${loaiCuocText}:`} className='col-25 mb10' value={Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : ''} />
                      <Text label='Ngày ban hành:' className='col-25 mb10' value={Data.ngayBanHanhKetLuanThanhTra ? moment(Data.ngayBanHanhKetLuanThanhTra).format('DD/MM/YYYY') : ''} />
                      <Text label='Đơn vị ban hành:' className='col-25 mb10' value={donViBanHanh} />
                    </div>
                    <div className='col-100 no-gutter'>
                      <Text label='Số quyết định xử lý:' className='col-25 mb10' value={Data.soQuyetDinhXuLy ? Data.soQuyetDinhXuLy : ''} />
                      <Text label='Ngày ban hành:' className='col-25 mb10' value={Data.ngayBanHanhQuyetDinhXuLy ? moment(Data.ngayBanHanhQuyetDinhXuLy).format('DD/MM/YYYY') : ''} />
                    </div>
                    <TextMessage label={`Tóm tắt kết luận ${loaiCuocText}:`} className='col-100 mb10' value={Data.tomTatKetLuanThanhTra ? Data.tomTatKetLuanThanhTra : ''} />
                  </div>
                </section>
              </div>
            </ShowIf>
          </Collapse>
          <ShowIf condition={true}>
            <div className='pl20 pr20'>
              <div className='wrap-big-line'>
                <div className='big-border'></div>
              </div>

              <h2 className={`collapse-title pt15 pb15 ${this.state.showThongTinTheoDoi ? "collapse-open" : "collapse-close"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showThongTinTheoDoi')}>2. Thông tin theo dõi thực hiện</Link></h2>
              <Collapse className="wrap-collapses" isOpen={this.state.showThongTinTheoDoi}>
                <div className='mb15'>
                  <div className='line-border'></div>
                </div>
                <section className='wrap-block'>
                  <h2 className='title-12 mb10'>2.1. Văn bản chỉ đạo của cấp trên</h2>
                  <div className='row pl10 pr10'>
                    <Input className='col-25 mb10' label='Số văn bản' triggeOnBlur={true} bindValidator={this} require channel='formTaoDon' value={this.state.soVanBanChiDaoCuaCapTren} onChange={this.onChange.bind(this, 'soVanBanChiDaoCuaCapTren')} name='soVanBanChiDaoCuaCapTren' maxLength={255} />
                    <DatePicker className='col-25 mb10' label='Ngày ban hành' triggeOnBlur={true} bindValidator={this} require channel='formTaoDon' value={this.state.ngayBanHanhVanBanChiDaoCuaCapTren} endDate={new Date()} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhVanBanChiDaoCuaCapTren')} name='ngayBanHanhVanBanChiDaoCuaCapTren' />
                    <DropDownMulipleUse className='col-25 mb10' label='Cơ quan ban hành' data={this.state.dataDonViBanHanh} keyName='giaTri' valueName='ten' selectedValue={this.state.coQuanBanHanhChiDaoCuaCapTren} onChange={this.onChange.bind(this, 'coQuanBanHanhChiDaoCuaCapTren')} name='coQuanBanHanhChiDaoCuaCapTren' />
                    <TextArea className='col-100 mb10' label='Ghi chú' value={this.state.ghiChuVanBanChiDaoCuaCapTren} onChange={this.onChange.bind(this, 'ghiChuVanBanChiDaoCuaCapTren')} name='ghiChuVanBanChiDaoCuaCapTren' maxLength={1000} />
                  </div>
                </section>
                <ShowIf condition={this.state.showFile}>
                  <ContainerFileDinhKem
                    phanLoaiQuyTrinh='CHI_DAO_CAP_TREN'
                    name='vanBanChiDaoCuaCapTren'
                    labelClass="title-12"
                    loaiVanBanSuggest='CHI_DAO_CAP_TREN'
                    soVanBanSuggest={this.state.soVanBanChiDaoCuaCapTren}
                    ngayQuyetDinhSuggest={this.state.ngayBanHanhVanBanChiDaoCuaCapTren}
                    label="Danh sách văn bản xử lý"
                    bindValidator={this}
                    data={this.state.listTaiLieuChiDaoCuaCapTren}
                    onFileRemove={this.onFileRemove.bind(this)}
                    onFileChange={this.onFileChange.bind(this)} />
                </ShowIf>
                <div className='pt10 pb20'>
                  <div className='line-border' />
                </div>
                <section className='wrap-block'>
                  <h2 className='title-12 mb10'>2.2. Văn bản báo cáo kết quả thực hiện kết luận {loaiCuocText}</h2>
                  <div className='row pl10 pr10'>
                    <Input className='col-25 mb10' label='Số văn bản' bindValidator={this} require channel='formTaoDon' value={this.state.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra} onChange={this.onChange.bind(this, 'soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra')} name='soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra' maxLength={255} />
                    <DatePicker className='col-25 mb10' label='Ngày ban hành' bindValidator={this} endDate={new Date()} require channel='formTaoDon' value={this.state.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT')} name='ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT' />
                    <DropDownMulipleUse className='col-25 mb10' label='Cơ quan ban hành' data={this.state.dataDonViBanHanh} keyName='giaTri' valueName='ten' selectedValue={this.state.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra} onChange={this.onChange.bind(this, 'coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra')} name='coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra' />
                    <TextArea className='col-100 mb10' label='Ghi chú' value={this.state.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra} onChange={this.onChange.bind(this, 'ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra')} name='ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra' maxLength={1000} />
                  </div>
                </section>
                <ShowIf condition={this.state.showFile}>
                  <ContainerFileDinhKem
                    name='ketQuaThucHienKetLuanThanhTra'
                    phanLoaiQuyTrinh='KET_QUA_THUC_HIEN_KET_LUAN_THANH_TRA'
                    labelClass="title-12"
                    label="Danh sách văn bản xử lý"
                    bindValidator={this}
                    data={this.state.listTaiLieuKetQuaThucHienKetLuanThanhTra}
                    onFileRemove={this.onFileRemove.bind(this)}
                    onFileChange={this.onFileChange.bind(this)} />
                </ShowIf>
                <div className='pt10 pb20'>
                  <div className='line-border' />
                </div>
                <section className='wrap-block pb10'>
                  <h2 className='title-12 mb10'>2.3. Kết quả thực hiện kết luận {loaiCuocText}</h2>
                  <div className='row pl15 pr15'>
                    <NoiDungKienNghi setEnableKetThuc={this.setEnableKetThuc.bind(this)} linhVucThanhTra={Data.linhVucThanhTra ? Data.linhVucThanhTra : ''} chucNangCuocThanhTra={Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : ''} listDoiTuongViPham={this.state.listDoiTuongViPham} onRef={noiDungKienNghi => (this.noiDungKienNghi = noiDungKienNghi)} type={this.state.type} id={this.state.id} />
                  </div>
                </section>
                <ShowIf condition={this.state.showFile}>
                  <ContainerFileDinhKem
                    labelClass="title-12"
                    name='taiLieuVanThuThanhTra'
                    label="2.4. Danh sách văn bản xử lý"
                    bindValidator={this}
                    data={this.state.listTaiLieuVanThuThanhTra}
                    dataShow={this.state.listTaiLieuVanThuThanhTraView}
                    onFileRemove={this.onFileRemove.bind(this)}
                    onFileChange={this.onFileChange.bind(this)} />
                </ShowIf>

              </Collapse>
            </div>
          </ShowIf>
        </div>

        <div className="action-form-wrap pl0 pr0 pt35 pb5">
          <div className="box-bottom">
            <Link className="btn-action btn-close" onClick={this.handleBack.bind(this, false, 'close')}><span>Đóng</span></Link>
            <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
            <ShowIf condition={this.state.enableKetThuc}>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this)}><span>Lưu hồ sơ</span></Link>
            </ShowIf>
          </div>
        </div>
        <Dialog
          isOpen={this.state.showDoiTuongThanhTra}
          onClose={this.hideDoiTuongThanhTra.bind(this)}
          title={`Thông tin đối tượng ${loaiCuocText}`}
          className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body mb0">
            <div className='row pl15 pr15'>
              <Text className='col-50 mb10' label="Tên đối tượng:" value={Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.ten : ''} />
              <Text className='col-50 mb10' label='Nhóm đối tượng:' value={Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.nhomDoiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.nhomDoiTuongThanhTraInfo.ten ? Data.doiTuongThanhTraInfo.nhomDoiTuongThanhTraInfo.ten : ''} />
              <Text className='col-50 mb10' label="Địa chỉ:" value={Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.diaChi : ''} />
              <Text className='col-50 mb10' label="Ghi chú:" value={Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.ghiChu : ''} />
              <Text className='col-50 mb10' label="Loại đối tượng:" value={Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo.text : ''} />
              <Text className='col-50 mb10' label="Ngành/Lĩnh vực:" value={Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.linhVucDoiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.linhVucDoiTuongThanhTraInfo.ten : ''} />
              <Text className='col-50 mb10' label="Số điện thoại:" value={Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.soDienThoai ? Data.doiTuongThanhTraInfo.soDienThoai : ''} />
            </div>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.hideDoiTuongThanhTra.bind(this)}><span>Đóng</span></Link>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.state.isOpenConfirm}
          onClose={this.closeDialog.bind(this)}
          title='Xác nhận lưu hồ sơ'
          className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body mb0">
            <p className='reception-dialog-text'>Bạn có muốn lưu hồ sơ này?</p>
          </div>
          <div className="box-bottom col-100 mt20">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialog.bind(this)}><span>Không</span></Link>
            <Link className="btn-action btn-green action-todo" onClick={this.handleKetThuc.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
        <ChiTietDoiTuongThanhTraDialog name="chiTietDT" data={Data} open={this.state.chiTietDT} onClose={this.toggleDialog.bind(this)} />
      </div>
    );
  }
}

XuLyTheoDoiThucHien.defaultProps = {
  validators: {
    formTaoDon: []
  },
  type: 'DOT_XUAT'
}

export default XuLyTheoDoiThucHien;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/XuLyTheoDoiThucHien.jsx